import { useState, useEffect, useRef, useCallback, Fragment, useMemo } from "react";
import { v4 } from "uuid";

/* 
clear 重覆點的話 可以反向選取 也就是變成無選取 變成null
*/
const TabList = ({ selectId, set_selectId, list, ItemCls, clear }) => {
    useEffect(() => {
    }, [selectId])
    return (
        <>
            {list.map((v, k) => {
                let isSelect = selectId === k;
                return <ItemCls key={k} isSelect={isSelect} data={v} selectId={selectId} index={k} onClick={ind => {
                    if (clear && ind === selectId) {
                        set_selectId(null);
                    }
                    else
                        set_selectId(ind);
                }} />
            })}
        </>
    );
}

export default TabList;